/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 09:46:54
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-07 16:18:33
 * @FilePath: /dbrank_b/src/routes/visualChart/components/DBTable/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import s from './index.css';
import classNames from 'classnames';

class DBTable extends Component {
  static propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
  }

  realColumns = []

  /** 单个表头渲染逻辑 */
  renderTh = (item, index, deep) => {
    const style = typeof item.style === 'function' ? item.style(item, index) : item.style;
    const children = item.children;
    const tdProps = {
      key: `${item.title}_${index}_${item.dataIndex}`,
      style: {...(style || {})},
    }
    if (Array.isArray(children) && children.length > 0) {
      tdProps.colSpan = children.length;
    } else {
      if (deep > 1) {
        tdProps.rowSpan = deep;
      }
    }
    return (<th {...tdProps} dangerouslySetInnerHTML={{__html: item.title}} />)
  }

  /** 
   * 生成所有表头th
   * 返回支持渲染数据的表头
   */
  createThList = (columns, maxDeep, deep = 0, list = []) => {
    const result = list
    if (!result[deep]) {
      result[deep] = []
    }
    columns.forEach((column, index) => {
      result[deep].push(this.renderTh(column, index, maxDeep - deep));

      if (Array.isArray(column.children)) {
        this.createThList(column.children, maxDeep, deep + 1, result)
      } else {
        this.realColumns.push(column);
      }
    });

    return result;
  }

  getDeepAndLength = (columns, deep = 1) => {
    let localDeep = deep;
    let localLength = 0;

    columns.forEach(ele => {
      if (Array.isArray(ele.children)) {
        const [childDeep, length] = this.getDeepAndLength(ele.children, deep + 1);
        localDeep = Math.max(childDeep, localDeep);
        localLength += length;
      } else {
        localLength += 1
      }
    });

    return [localDeep, localLength]
  }

  /** 渲染thead */
  renderHeader = () => {
    const { columns = [] } = this.props;
    this.realColumns = [];
    const [maxDeep] = this.getDeepAndLength(columns);
    const tdList = this.createThList(columns, maxDeep);

    return (
      <thead>
        {tdList.map((ele, index) => (<tr key={`head_${index}`}>{ele}</tr>))}
      </thead>
    )
  }

  getTdRowSpanNumAndMerged = (list, key, index) => {
    let count = 1;
    // -1: 不生成dom  0：只生成dom没有合并 1：生成dom并且会合并
    let isMerge = 0;
    const prev = list[index - 1];
    const value = list[index][key];

    if (index > 0 && prev[key] === value) {
      isMerge = -1;
    } else {
      while(index + count < list.length) {
        const nextValue = list[index + count][key];
        if (nextValue !== value) {
          break;
        }
        // 肯定有一个合并的
        isMerge = 1;
        count += 1;
      }
    }

    return [isMerge, count]
  }
  renderBodyTr = (record, index, list) => {
    const columns = this.realColumns


    return (
      <tr key={`${record.id}_${index}`}>
        {columns.map((column, _index) => {
          const sourceValue = record[column.dataIndex];
          const value = sourceValue === undefined && sourceValue === null ? '' : sourceValue;
          const colStyle = typeof column.colStyle === 'function' ? column.colStyle(column, index, _index) : column.colStyle;

          const tdProps = {
            key: `${record.id}_${index}_${_index}`,
            style: {...(colStyle || {})}
          }

          if(column.mergeRow) {
            const [isMerge, count] = this.getTdRowSpanNumAndMerged(list, column.dataIndex, index);
            if (isMerge === -1) {
              return null;
            } else if (isMerge === 1) {
              tdProps.rowSpan = count;
            }
          }

          return (
            <td {...tdProps}>
              {column.render ? column.render(value, record, index, _index) : value}
            </td>
          )
        })}
      </tr>
    )
  }

  renderBody = () => {
    const { data = [] } = this.props;

    return (
      <tbody>
        {data.map((record, index) => this.renderBodyTr(record, index, data))}
      </tbody>
    )
  }

  render() {
    const { className, style } = this.props;
    return (
      <table
        style={style}
        className={classNames(s.homeTable, className)}
        cellSpacing="0"
        cellPadding="0">
        {this.renderHeader()}
        {this.renderBody()}
      </table>
    )
  }
}

export default withStyles(s)(DBTable);



// WEBPACK FOOTER //
// src/routes/visualChart/components/DBTable/index.js